module.exports = __webpack_public_path__ + "img/gd.b402c8c.svg";